import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { useMedia } from '@tager/web-core';

import { useTypedSelector } from '@/store/store';
import { media } from '@/utils/mixin';
import { selectSinglePost } from '@/store/reducers/single-post';
import { useDOMParser } from '@/modules/SinglePost/components/utils';
import { handleScrollToDomElement } from '@/utils/scroll';
import { HideScrollbar } from '@/components/styles';

function BottomNavigation() {
  const page = useTypedSelector(selectSinglePost);
  const titles = useDOMParser({
    body: page?.body,
    selectors: 'h3',
  });
  const isMobile = useMedia('(max-width: 767px)');
  const navRef = useRef<HTMLDivElement>(null);

  const componentRef = useRef<HTMLDivElement>(null);

  if (!page) {
    return null;
  }

  return (
    <Component ref={componentRef}>
      <Sticky>
        <NavWrapper ref={navRef} id="overview-content-nav-wrapper">
          <Nav className="nav-ul">
            {(titles ?? []).map((text, index) => (
              <AnchorButton
                key={index}
                className={`nav-button-section-${index} nav-button-section-item`}
                onClick={() => handleScrollToDomElement(`section-${index}`)}
              >
                {text}
              </AnchorButton>
            ))}
            {isMobile && <Plug />}
          </Nav>
        </NavWrapper>
      </Sticky>
    </Component>
  );
}

export default BottomNavigation;

const Component = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  height: 60px;

  background: ${(props) => props.theme.gray_1};
  box-shadow: ${(props) => props.theme.blackShadow100};

  transition: transform 0.4s ease;

  transform: translateY(0);

  ${HideScrollbar}

  ${media.tablet(css`
    top: 80px;
  `)}

  ${media.mobile(css`
    top: 60px;
  `)}
`;

const NavWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px 0;
  transition: all 0.7s ease;
`;

const Sticky = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  overflow-y: auto;

  padding: 0 90px;

  ${media.tablet(css`
    padding: 0;
  `)}
`;

const Plug = styled.div`
  padding: 1px;

  margin-left: -10px;
`;

const Nav = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 0;
  max-width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  height: 100%;

  ${media.mobile(css`
    max-width: 100%;
  `)}
`;

const AnchorButton = styled.button<{ isActive?: boolean }>`
  font-weight: 300;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: ${(props) => props.theme.black100_alpha50};

  white-space: nowrap;

  transition: color 0.15s ease-in-out;

  &:not(:last-child) {
    margin-right: 30px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      font-weight: 700;
    `};

  @media (min-width: 1600px) {
    margin-right: 0;
    font-size: 20px;
    line-height: 33px;
  }
`;
